import { Vue, Component, Prop } from 'vue-property-decorator';
import GradeCard from '../../showcase/grade-card/grade-card';
@Component({
  name: 'facet-search-card',
  components: {
    'grade-card': GradeCard,
  },
})
export default class FacetSearchCardComponent extends Vue {
  // --------------------------------------------------------
  // Properties

  @Prop()
  public content: any;

  @Prop({ default: false })
  public isCourseTag!: boolean;

  public get cardFormat() {
    const content = this.content;
    const format = content.format || content.type || content.contentFormat;
    return format;
  }

  public get subFormat() {
    const content = this.content;
    const subFormat = content.contentSubFormat;
    return subFormat;
  }

  // public get contentType() {
  //   const contentType: any = CONTENT_TYPE_MAPPING;
  //   return contentType[this.cardFormat] || this.cardFormat;
  // }

  // public get contentItems() {
  //   const cardSource: any = FACET_CARD_CONTENT_KEYS;
  //   return cardSource[this.cardFormat];
  // }

  public get competencyDesc() {
    const { standards } = this.content;
    const standard =
      standards && standards.length
        ? standards.find((item: any) => item.title)
        : {};
    return standard ? standard.title : null;
  }

  // --------------------------------------------------------
  // Hooks

  // --------------------------------------------------------
  // Actions

  public onSelectMarker() {
      this.$emit('onSelectMarker', this.content);
  }
}
